"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var tyrande_1 = require("tyrande");
var mobx_react_1 = require("mobx-react");
var redeem_1 = require("./redeem");
var WithEZSpm_1 = require("components/WithEZSpm");
var store_1 = require("./store");
var ezbuyAppUtil_1 = require("mobile/utils/ezbuyAppUtil");
var debug_1 = require("utils/debug");
var style_1 = require("./style");
var css_1 = require("mobile/utils/css");
var Games = (function (_super) {
    __extends(Games, _super);
    function Games(props) {
        var _this = _super.call(this, props) || this;
        _this.genTSpmLinkByUrl = function () {
            var index = _this.props.index;
            var _a = _this.props.spm, activityId = _a.activityId, pageId = _a.pageId, componentType = _a.componentType, site = _a.site;
            var params = {
                site: site,
                activityId: activityId,
                pageId: pageId,
                channel: String(index),
                channelContent: {
                    type: componentType,
                    content: _this.props.moduleDetail && _this.props.moduleDetail.id
                }
            };
            tyrande_1.sendEzspm(params, {}, false);
        };
        _this.handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.genTSpmLinkByUrl();
                        return [4, this.store.moduleEvent(this.props.moduleDetail.id)];
                    case 1:
                        if (_a.sent()) {
                            this.changeShow(true);
                        }
                        return [2];
                }
            });
        }); };
        _this.changeShow = function (show) {
            _this.setState({
                show: show
            });
        };
        _this.linkTo = function () {
            var origin = "";
            if (debug_1.isUAT()) {
                origin = "https://m3.sg.65emall.net";
            }
            else {
                origin = "https://m.ezbuy.sg";
            }
            var href = "ezbuyapp://web?url=" + origin + "/app/honeyHunt/" + _this.store.activeId + "&toolbarVisible=false&statusbarVisible=false";
            if (ezbuyAppUtil_1.isFromEzbuyapp() || ezbuyAppUtil_1.isFromEzbuyint()) {
                window.location.href = href;
            }
            else {
                window.location.href = href;
                setTimeout(function () {
                    window.location.pathname = "/appDownload";
                }, 2000);
            }
        };
        _this.state = {
            show: false
        };
        _this.store = new store_1.GamesStore(props.moduleDetail);
        return _this;
    }
    Games.prototype.render = function () {
        var _this = this;
        var _a = this.props, index = _a.index, addModuleMap = _a.addModuleMap, commonProps = _a.commonProps;
        var show = this.state.show;
        var banner = this.store.banner;
        return (React.createElement("div", { id: commonProps.id, ref: function (node) {
                if (node) {
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            }, style: {
                width: css_1.px2rem(351),
                height: css_1.px2rem(80)
            } },
            React.createElement(style_1.GamesBanner, { src: banner, onClick: this.handleClick }),
            React.createElement(redeem_1.default, { show: show, onClose: function () { return _this.changeShow(false); }, onEnter: this.linkTo })));
    };
    Games = __decorate([
        mobx_react_1.observer
    ], Games);
    return Games;
}(React.Component));
exports.default = WithEZSpm_1.default(Games);
